module.exports = __webpack_public_path__ + "static/media/c-male.49601843.png";